import * as React from "react";

export interface FunctionsListItemProps {
  imgSrc: string;
  headerText: string;
  text: string;
}

const FunctionsListItem = (props: FunctionsListItemProps): JSX.Element =>
  <div className="feature-list__item">
    <img src={props.imgSrc} />
    <h3>
      {props.headerText}
    </h3>
    <p>
      {props.text}
    </p>
  </div>;

export default FunctionsListItem;



// WEBPACK FOOTER //
// ./src/routes/LandingPage/components/FunctionsListItem.tsx